module.exports = __webpack_public_path__ + "static/media/dev-social-media.f64ca805.png";